import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ButtonOnLight } from '../buttons';

export default function ErrorOld({
  code,
  title,
  subtitle,
  route = '/',
  bgColor = 'colorTheme.backgroundPrimaryLightWeb',
}) {
  return (
    <Box
      display='grid'
      backgroundColor={bgColor}
      height='75vh'
      justifyContent='center'
      alignItems='center'
      gridTemplateColumns='repeat(14, 1fr)'
      columnGap={{ xs: 1, md: 3, lg: 6 }}
      mb={8}
    >
      <Box gridColumn={{ xs: '-1/1', sm: '3/9' }} mx={4}>
        <Typography variant='h1' sx={{ fontSize: { xs: '100px' } }} color='colorTheme.contentPrimaryOnLight'>
          {code}
        </Typography>

        <Box my={4}>
          <Typography variant='h2' color='colorTheme.contentPrimaryOnLight'>
            {title}
          </Typography>
        </Box>

        {subtitle && (
          <Box my={4}>
            <Typography variant='bodyL' color='colorTheme.contentPrimaryOnLight'>
              {subtitle}
            </Typography>
          </Box>
        )}

        <Box marginTop='100px' width='156px'>
          <ButtonOnLight href={route}>
            <Typography variant='buttonL'>Go home</Typography>
          </ButtonOnLight>
        </Box>
      </Box>
    </Box>
  );
}
